module.exports = __webpack_public_path__ + "img/pikantesalat-cutted.1d345df3.png";